export enum FormField {
  LivingCircumstance = 'livingCircumstance',
  HomeOwnershipStatus = 'homeOwnershipStatus',
  SellingStatus = 'sellingStatus',
  FirstTimeBuyerStatus = 'firstTimeBuyerStatus',
  PropertyStatus = 'propertyStatus',
}
